export default __webpack_public_path__ + "static/media/login-internal.9a5965a9.png";